import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";

export const LiveCasinoGridItemClosedMessageDefaultBox = styled.div`
  padding-top: 2em;
  font-size: 0.85rem;
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.25;
  color: ${props => props.theme.colors.bodyText};
  background: ${props => hexToRgba(props.theme.components.newLiveCasino.colors.gridItem.closedMessageBackground, 0.9)};

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, ${props => props.theme.colors.buttonLight}, transparent);
  }

  & > span {
    display: block;
    width: 100%;
    font-size: 1.6em;
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding-top: 2em;
    font-size: 0.85rem;
  }
`;